import echarts from "echarts";

export default {
  name: "chart-line",
  props: {
    id: {
      type: String,
      default() {
        return "";
      }
    },
    xAxisData: [Object,Array],  //X轴数据
    seriesData: [Object,Array],  //Y轴数据
    titles: [Object,Array],
  },
  data() {
    return {
      chartDom: null,
      data: {
        id: this.id,
        list: this.dataList,
        titles: this.titles,
        seriesData:this.seriesData,
        xAxisData:this.xAxisData,
      },

    };
  },

  mounted() {
    this.init().update()
  },

  methods: {
    init() {
      // 基于准备好的dom，初始化echarts实例
      if (this.data) {
        this.chartDom = echarts.init(document.getElementById(this.data.id));
      }
      return this;
    },

    update() {
      if (this.chartDom === null) {
        this.init();
      }
      if (this.chartDom) {
        this.chartDom.setOption({
          color: ["#4472c4", "#ffc000", "#a5a5a5", "#ed7d31", "#5b9bd5"],
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: this.data.titles,
            orient: "vertical",
            right: 0,
            top: "40%"
          },
          grid: {
            left: "2%",
            right: "8%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.data.xAxisData
          },
          yAxis: [{
            type: "value",
            splitLine:{
              // show:false,
            }
          },{
            type: "value",
            splitLine:{
              show:false,
            }
          }],
          series: this.data.seriesData
        });
      }
    },

  },

  watch: {
    seriesData(v) {
     if(v){
       this.data.seriesData = v;
       this.init().update()
    
    
     }
    },
    xAxisData(v) {
     if(v){
      this.data.xAxisData = v;
      this.init().update()
    
     }
    }
   
  }
};



// WEBPACK FOOTER //
// ./src/components/echarts/line/default/Default.js